import React from 'react';
import { Image } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { AdvertEntity } from '../../../domain';
import { AdvertAttachmentsService } from '../../../domain';
import HtmlTextRenderer from '../HtmlTextRenderer';
import './AdvertInfo.styles.css';

type TAdvertInfoProps = { advertModel: AdvertEntity };

const AdvertInfo: React.FC<TAdvertInfoProps> = ({ advertModel }) => {
  const description = advertModel.description;

  const sortedAttachments = AdvertAttachmentsService.reorder(advertModel.attachments || []);
  const images = AdvertAttachmentsService.images(sortedAttachments);

  const currentTime = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  const imageCount = images.length;
  const imageLayoutClass = imageCount > 0 ? `image-count-${imageCount}` : '';

  return (
    <div className="phone-frame">
      <div className="phone-screen">
        <div className="advert-preview-container">
          <div className="telegram-message-bubble outgoing">
            {images.length > 0 && (
              <div className={`message-images ${imageLayoutClass}`}>
                <Image.PreviewGroup>
                  {images.map((attachment, index) => (
                    <div key={index} className="message-image-wrapper">
                      <Image src={attachment.url} className="message-image-item" />
                    </div>
                  ))}
                </Image.PreviewGroup>
              </div>
            )}
            <div className="message-content">
              <HtmlTextRenderer htmlContent={description} />
            </div>
            <div className="message-meta">
              <span className="message-timestamp">{currentTime}</span>
              <CheckOutlined className="message-status-icon" />
              <CheckOutlined className="message-status-icon double-check" />
            </div>
          </div>
        </div>
      </div>
      <div className="phone-top-details">
        <div className="phone-speaker"></div>
        <div className="phone-camera"></div>
      </div>
      <div className="phone-bottom-bar"></div>
    </div>
  );
};

export default AdvertInfo;